import '@mantine/core/styles.css';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { App } from './App';
import { isgCssDegiskenleri, theme } from './theme';

/**
 * Sağlayıcı zinciri (F1·S10): Mantine (tema token'ları tek noktadan) +
 * TanStack Query (sunucu verisi — v1'de TEK durum katmanı; genel durum
 * deposu BİLİNÇLİ kurulmadı, Teknoloji v1.7) + Router.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Salt-okunur görüntüleme: kısa önbellek yeter; 401/403 yeniden
      // denemekle düzelmez (retry sorgu başına ayarlanmaz, ekran hatayı gösterir).
      staleTime: 30_000,
      retry: false,
    },
  },
});

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root bulunamadı');

createRoot(rootElement).render(
  <StrictMode>
    <MantineProvider theme={theme} cssVariablesResolver={isgCssDegiskenleri}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
